import SectionLayout from '@common/containers/layouts/SectionLayout';

function Loading() {
  return <SectionLayout showLoadingSpinner />;
}

export default Loading;
